module.exports = __webpack_public_path__ + "img/one_step.7928632a.svg";